const MODULE_NAME = 'PATIENT_SURVEY_TRIGGERS';
const PATIENT_TRIGGERS_FETCH_STARTED = MODULE_NAME + 'FETCH_STARTED';
const PATIENT_TRIGGERS_FETCH_COMPLETED = MODULE_NAME + 'FETCH_COMPLETED';

export {
  PATIENT_TRIGGERS_FETCH_COMPLETED,
  PATIENT_TRIGGERS_FETCH_STARTED
};
